"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaBreakpoints = void 0;
exports.mediaBreakpoints = {
    sm: '(max-width: 359px)',
    md: '(min-width: 360px) and (max-width: 1023px)',
    lg: '(min-width: 1024px) and (max-width: 1279px)',
    xl: '(min-width: 1280px) and (max-width: 1439px)',
    xxl: '(min-width: 1440px) and (max-width: 1919px)',
    xxxl: '(min-width: 1920px)',
};
